const southAfrica = {
  Gauteng: [
    "Johannesburg",
    "Pretoria",
    "Soweto",
    "Midrand",
    "Sandton",
    "Centurion",
    "Kempton Park",
    "Benoni",
    "Boksburg",
    "Alberton",
    "Roodepoort",
    "Randburg",
  ],

  "Western Cape": [
    "Cape Town",
    "Stellenbosch",
    "Paarl",
    "George",
    "Mossel Bay",
    "Hermanus",
    "Worcester",
    "Somerset West",
  ],

  "KwaZulu-Natal": [
    "Durban",
    "Pietermaritzburg",
    "Richards Bay",
    "Newcastle",
    "Ladysmith",
    "Empangeni",
    "Ballito",
    "Port Shepstone",
  ],

  "Eastern Cape": [
    "Gqeberha",
    "East London",
    "Mthatha",
    "Queenstown",
    "Grahamstown",
    "Jeffreys Bay",
    "Uitenhage",
  ],

  "Free State": [
    "Bloemfontein",
    "Welkom",
    "Bethlehem",
    "Kroonstad",
    "Sasolburg",
    "Virginia",
  ],

  Limpopo: [
    "Polokwane",
    "Tzaneen",
    "Mokopane",
    "Louis Trichardt",
    "Musina",
    "Thohoyandou",
  ],

  Mpumalanga: [
    "Mbombela",
    "Witbank",
    "Secunda",
    "Middelburg",
    "Ermelo",
    "Standerton",
  ],

  "North West": [
    "Mahikeng",
    "Rustenburg",
    "Klerksdorp",
    "Potchefstroom",
    "Brits",
    "Lichtenburg",
  ],

  "Northern Cape": [
    "Kimberley",
    "Upington",
    "Kuruman",
    "Springbok",
    "De Aar",
    "Colesberg",
  ],
};

export default southAfrica;